import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';
import { format, parseISO } from 'date-fns';

const AttendanceDeleteDialog = ({ open, attendanceToDelete, onCancel, onConfirm }) => {
  const formatDate = (dateString) => {
    try {
      return format(parseISO(dateString), 'MMM dd, yyyy');
    } catch (error) {
      return dateString;
    }
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon color="error" />
        Confirm Delete
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete the attendance record for{' '}
          <strong>{attendanceToDelete?.employee?.full_name}</strong> on{' '}
          <strong>{attendanceToDelete?.date ? formatDate(attendanceToDelete.date) : 'N/A'}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This action cannot be undone. The attendance record will be permanently removed from the system.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="error" startIcon={<DeleteIcon />}>
          Delete Record
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AttendanceDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  attendanceToDelete: PropTypes.shape({
    employee: PropTypes.shape({
      full_name: PropTypes.string,
    }),
    date: PropTypes.string,
  }),
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

AttendanceDeleteDialog.defaultProps = {
  attendanceToDelete: null,
};

export default AttendanceDeleteDialog;